<template>
  <div class="link-upload-popup">
    <el-button type="primary" plain @click="showPopup">
      链接上传
      <i class="el-icon-link" />
    </el-button>

    <el-dialog
      :visible.sync="dialogVisible"
      width="524px"
      :before-close="handleClose"
    >
      <template v-slot:title>
        <p class="add-title">新增资讯链接</p>
      </template>

      <el-form ref="form" :model="queryInfo" label-width="110px">
        <el-form-item label="资讯链接：">
          <el-input
            v-model="queryInfo.link"
            placeholder="请输入链接"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// api
import { addByPath } from "@/api/news"

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    type: {
      type: String,
      default: "report"
    }
  },
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      queryInfo: {
        link: ""
      }
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    showPopup(e) {
      this.dialogVisible = true;

      let target = e.target;
      if (target.nodeName === "SPAN") {
        // span 标签
        target = e.target.parentNode;
      }
      target.blur();
    },
    submit() {
      if (this.type === "report") {
        addByPath({ url: this.queryInfo.link }).then(res => {
          this.$message.success("数据正在解析中，请稍后查看..............");
          this.$emit("updateList");
          this.queryInfo.link = "";
          this.dialogVisible = false;
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.link-upload-popup {
  .add-title {
    text-align: left;
    color: #333333;
  }
}
</style>
